import React from 'react'
import ImageWrapper from '../ImageWrapper/ImageWrapper'

function Card({icon, title, content}) {
  return (
    <div className='card border border-1 rounded text-center featureCard' style={{maxWidth: "300px"}} data-aos="fade-up" data-aos-duration="1000">
      <ImageWrapper image={icon}/>
      <div className="card-body">
        <h4 className='my-4'>{title}</h4>
        <p className='m-0 mb-4' style={{textAlign: "revert-layer"}}>{content}</p>
        <a href="https://api.whatsapp.com/send/?phone=6285241329911&text=Hallo+Black+Canyon+Transport+,%20Saya%20mau%20pesan%20mobil..." className="btn btn-primary py-2 px-3 text-end">Tekan untuk Order</a>
      </div>
    </div>
  )
}

export default Card